module.exports = __webpack_public_path__ + "static/media/cover-mobile-411x93.ada28134.jpg";